// extracted by mini-css-extract-plugin
export var divider = "_u1-0";
export var systemMessage = "_u1-1";